import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Info16 } from 'shared/assets/icons';
import { Icon } from 'shared/components/ui/icon';
import { MetaToggle } from 'shared/components/ui/meta-toggle';
import { Tooltip } from 'shared/components/ui/tooltip';

import * as Styled from './log-completion-value-toggle.style';

export type LogCompletionValueToggleProps = {
  value: boolean;
  onChange: (logCompletionValue: boolean) => void;
  fullWidth?: boolean;
  icon?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
};

export const LogCompletionValueToggle: React.FC<
  LogCompletionValueToggleProps
> = ({ value, onChange, fullWidth, icon }) => {
  const { t } = useTranslation();
  const tooltipRef = useRef<HTMLDivElement>(null);

  return (
    <MetaToggle
      label={t('general.labels.log-completion-value')}
      checked={value}
      onChange={onChange}
      fullWidth={fullWidth}
      icon={icon}
      id="log-completion-value-toggle"
      labelAdornment={
        <>
          <Tooltip
            label={t('general.labels.log-completion-value.tooltip')}
            referenceElement={tooltipRef}
          />
          <Styled.InfoIcon ref={tooltipRef}>
            <Icon icon={Info16} />
          </Styled.InfoIcon>
        </>
      }
    />
  );
};
